import { graphql, useFragment } from 'react-relay';

import { BoxFlex } from '@woovi/ui';

import type { PaymentActiveITP_charge$key } from './__generated__/PaymentActiveITP_charge.graphql.ts';
import PaymentActiveITPDetails from './PaymentActiveITPDetails.tsx';
import PaymentActiveITPValue from './PaymentActiveITPValue.tsx';
import ITPButton from '../../itp/ITPButton.tsx';
import PaymentLinkAdditionalInfo from '../../paymentLink/PaymentLinkAdditionalInfo.tsx';
import PaymentLinkComment from '../../paymentLink/PaymentLinkComment.tsx';
import PaymentLinkPaymentTerm from '../../paymentLink/PaymentLinkPaymentTerm.tsx';
import PaymentLinkActiveCashbackFidelityBalance from '../paymentLinkActive/PaymentLinkActiveCashbackFidelityBalance.tsx';
import PaymentLinkActiveEarnCashback from '../paymentLinkActive/PaymentLinkActiveEarnCashback.tsx';
import PaymentLinkActiveEarnCashbackFidelity from '../paymentLinkActive/PaymentLinkActiveEarnCashbackFidelity.tsx';
import PaymentLinkActiveEarnDiscount from '../paymentLinkActive/PaymentLinkActiveEarnDiscount.tsx';

import type { ReactNode } from 'react';

type PaymentActiveITPProps = {
  charge: PaymentActiveITP_charge$key;
};

const PaymentActiveITP = (props: PaymentActiveITPProps): ReactNode => {
  const charge = useFragment<PaymentActiveITP_charge$key>(
    graphql`
      fragment PaymentActiveITP_charge on Charge {
        ...PaymentActiveITPValue_charge
        ...PaymentLinkComment_charge

        ...PaymentLinkActiveEarnDiscount_charge
        ...PaymentLinkActiveEarnCashback_charge
        ...PaymentLinkActiveCashbackFidelityBalance_charge
        ...PaymentLinkActiveEarnCashbackFidelity_charge
        ...ITPButton_charge
        ...PaymentLinkPaymentTerm_charge
        ...PaymentActiveITPDetails_charge
        ...PaymentLinkAdditionalInfo_charge
      }
    `,
    props.charge,
  );

  return (
    <BoxFlex
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
        mt: '20px',
      }}
    >
      <BoxFlex
        sx={{
          justifyContent: 'center',
          flexDirection: 'column',
          display: 'flex',
          fontSize: '20px',
          fontWeight: 'bold',
        }}
      >
        <PaymentActiveITPValue charge={charge} />
        <PaymentLinkComment charge={charge} />
      </BoxFlex>

      <BoxFlex
        sx={{
          flexDirection: 'column',
        }}
      >
        <BoxFlex sx={{ flexDirection: 'column', alignItems: 'center' }}>
          <BoxFlex sx={{ flexDirection: 'column', gap: 1, my: 1 }}>
            <PaymentLinkActiveEarnDiscount charge={charge} />
            <PaymentLinkActiveEarnCashback charge={charge} />
            <PaymentLinkActiveCashbackFidelityBalance charge={charge} />
            <PaymentLinkActiveEarnCashbackFidelity charge={charge} />
          </BoxFlex>

          <BoxFlex
            sx={{
              flexDirection: 'column',
              gap: 1,
              maxWidth: '332px',
              width: '100%',
            }}
          >
            <ITPButton charge={charge} />
          </BoxFlex>
          <PaymentLinkPaymentTerm charge={charge} />
        </BoxFlex>
        <PaymentActiveITPDetails charge={charge} />
        <PaymentLinkAdditionalInfo charge={charge} />
      </BoxFlex>
    </BoxFlex>
  );
};

export default PaymentActiveITP;
